<template>
  <div>
    <b-button size="sm" @click="showBikouModal" :disabled="!item['activeRecord'] || item['additionalCount'] === 0" :variant="variant">{{$t('inbound.print')}}</b-button>
    <b-modal ref="printBarcodeModel" :title="statusText" hide-footer=true>
      <div class="d-block text-center" :id="item['asin']"></div>
      <b-btn class="mt-3" variant="outline-danger" block @click="toInbound">OK</b-btn>
      <b-btn class="mt-3" variant="outline-danger" block @click="toManage">キャンセル</b-btn>
      <!-- <b-btn class="mt-3" variant="outline-danger" block @click="toInboundToEnd">OK.入庫後にこの会員の入庫を終わる</b-btn> -->
      <b-btn v-show="moveFromProductMenu" class="mt-3" variant="outline-danger" block @click="returnTroubleMenu">OK.入庫後に管理品画面に戻る</b-btn>
    </b-modal>
    <b-modal ref="messagePopupSimple" @ok="showModalForAsin" hide-header>
      <div class="text-center">{{confirmMessageSimple}}</div>
    </b-modal>
    <b-modal ref="messagePopupSimple2" @ok="showModal" hide-header>
      <div class="text-center">{{confirmMessageSimple}}</div>
    </b-modal>
    <b-modal ref="printBarcodeModelDanger" :title="statusText" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" hide-footer=true>
      <b-btn class="mt-3" variant="outline-danger" block @click="toManage">OK</b-btn>
    </b-modal>
  </div>
</template>

<script>
import * as api from '@/api';
import ShippingType from '@/types/ShippingType';

export default {
  props: {
    memberId: { default: '' },
    title: { default: '' },
    url: { default: '' },
    status: { default: '' },
    item: { default: [] },
    variant: { default: '' },
    // btnType: { default: '0'},
    janFilter: { default: ''},
    statusFilter: { default: '1'},
    moveFromProductMenu: { default: false}
    // isMemberId: { default: '0'}
  },
  data() {
    return {
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      // isUpdatedOnlyManage: false,
      // moveFromProductMenu: false,
      updateStatus: '',
      confirmMessageSimple: '',
      isPastData: false,
      // updateStatusTmp: '',
      isDangerPopup: '0',
      isToEndInbound: false,
      isReturnTroubleMenu: false,
      isOutputBarcode: true,
    };
  },
  computed: {
    statusText() {
      // [優先度1] 数量不一致(7)
      if(this.updateStatus.indexOf('07') !== -1) {
        // this.isUpdatedOnlyManage = true;
        // return '数量が在庫を超過しています。管理品への登録を実施しますか？';
        return '未受数量を超過した入庫はできません';
      }
      // [優先度2] 返品依頼(5), 廃棄依頼(6) ※本依頼がある場合は、原則管理品登録は行わない。
      if (this.updateStatus.indexOf('05') !== -1 || this.updateStatus.indexOf('06') !== -1){
        if(this.isPastData){
          return '１ヶ月以上前の依頼ですが入庫しますか？';
        }
        return '商品を入庫しますか？';
      }
      // [優先度3] SKU登録無し(1), ASIN無効(2)
      if (this.updateStatus.indexOf('01') !== -1 || this.updateStatus.indexOf('02') !== -1) {
        if(this.isPastData){
          return '本商品はラベル印刷できません。１ヶ月以上前の依頼ですが入庫しますか？';
        }
        return '本商品はラベル印刷できません。商品を入庫しますか？';
      }
      // [優先度4] 正常パターン
      if(this.isPastData){
        return '１ヶ月以上前の依頼ですが入庫しますか？';
      }
      return '商品を入庫しますか？';
    },
  },
  methods: {
    showBikouModal(){
      // 対象レコードの登録日が1カ月前か否かを確認する。
      var dt = new Date();
      dt.setMonth(dt.getMonth() - 1);

      var year = this.item['purchaseDate'].substring(0, 4);
      var month = this.item['purchaseDate'].substring(4, 6);
      var day = this.item['purchaseDate'].substring(6, 8);
      var yearI = parseInt(year, 10);
      var monthI = parseInt(month, 10);
      var dayI = parseInt(day, 10);
      var dtP = new Date(yearI, monthI, dayI);

      if(dt > dtP){
        this.isPastData = true;
      }

      // コメント有無をチェックする。
      let comment = this.item.comment;
      if(comment != null && comment !== ''){
        this.confirmMessageSimple = '備考欄にコメントが有ります。（' + comment + '）';
        this.$refs.messagePopupSimple.show();
      } else {
        this.showModalForAsin();
      }
    },
    showModalForAsin(){
      // 指定ASINの場合にメッセージを表示する。
      if(this.item['asin'] === 'B08NXS1WJ7'){
        this.confirmMessageSimple = '一度管理品へ登録してください';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B0002E1TB8'){
        this.confirmMessageSimple = '単品で入庫しないといけない商品です。';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B005Q5Y4EW'){
        this.confirmMessageSimple = 'ラベルが剥がれる為、袋に入れて入庫して下さい。';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B00UKF75SK' || this.item['asin'] === 'B014P7JYOQ'){
        this.confirmMessageSimple = '袋に入れて入庫';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B001LRLE60'){
        this.confirmMessageSimple = '異なるJAN 4種類×1枚ずつのセットです';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B08D15W3PK'){
        this.confirmMessageSimple = '２点１セットで入庫';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B008EGENIM'){
        this.confirmMessageSimple = 'プチプチに包む';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B08GQFB1RQ' || this.item['asin'] === 'B08F2YRT4V' || this.item['asin'] === 'B08GQDFTR5'){
        this.confirmMessageSimple = '袋に入れる';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B08GQFVQ21' || this.item['asin'] === 'B08GQH5KZ3' || this.item['asin'] === 'B08GRG5W4G'){
        this.confirmMessageSimple = '袋に入れる';
        this.$refs.messagePopupSimple2.show();
      } else if(this.item['asin'] === 'B002SE3DI2' || this.item['asin'] === 'B002SE3DJ6' || this.item['asin'] === 'B002SE1X34' || this.item['asin'] === 'B002SDW3AW' || this.item['asin'] === 'B002SE1X2A' || this.item['productNameEn'].includes('Nagaoka ')){
        this.confirmMessageSimple = '⚠️Transparency認証コードを隠さずに入庫・発送⚠️';
        this.$refs.messagePopupSimple2.show();
      } else {
        this.showModal();
      }
    },
    showModal() {
      // this.isUpdatedOnlyManage = false;
      this.updateStatus = '';
      this.updateStatus = this.item['status'];
      this.isDangerPopup='0';
      this.isToEndInbound = false;

      // 入庫数量＞未受数量の場合は、フラグを立てる。
      if(this.item['additionalCount'] > this.item['unInboundQuantity']) {
        this.updateStatus = '07';
        this.isDangerPopup='1';
        this.confirmMessageSimple = '未受数量を超過した入庫はできません';
        this.$refs.printBarcodeModelDanger.show();
      } else if(this.updateStatus.indexOf('01') !== -1 || this.updateStatus.indexOf('02') !== -1 || this.updateStatus.indexOf('05') !== -1 || this.updateStatus.indexOf('06') !== -1){
        // SKU登録無し(1), ASIN無効(2), 返品依頼(5), 廃棄依頼(6), 数量不一致(7)はラベル印刷しない為、いきなりポップアップ表示する。
        this.isOutputBarcode = false;
        this.$refs.printBarcodeModel.show();
      } else{
        this.isOutputBarcode = true;
        this.$refs.printBarcodeModel.show();
        // this.printBarcode();
      }
    },
    printBarcode() {
      const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');
      var con = this.item['productCondition'] === '0' ? 'NEW' : 'USED';
      var pname = this.item['productNameEn'].substring(0, 25);
      var printUrl = '';
      // var fnsku = this.item['fnsku'].replace('E', 'e');
      var fnsku = this.item['fnsku'];
      // ラベルに表示する会員番号を成形
      var memberNumber = this.memberId.substr(7);
      var memberNumberOne = this.memberId.substr(7,1);
      if(memberNumberOne.search(/[A-Z]/) >= 0){
        memberNumber = memberNumberOne.toLowerCase() + '_' + this.memberId.substr(8);
      }
      if(this.item['matomeStatus']){
        printUrl = '<div style="text-align:center"><img src="' + this.url + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>' + memberNumber + ' <label style="background-color:black;color:white;border-radius:1rem;padding-left:0.5rem;padding-right:0.5rem">M</label></div>';
      } else{
        printUrl = '<div style="text-align:center"><img src="' + this.url + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>' + memberNumber + '</div>';
      }
      // console.log("aaa");
      WinPrint.document.body.innerHTML = printUrl;
      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            WinPrint.window.print();
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.close();
            // this.$refs.printBarcodeModel.show();
          }, waitSeconds)
        })
      }
      sleep(500);
    },
    toManage() {
      if(this.isDangerPopup === '1'){
        this.$refs.printBarcodeModelDanger.hide();
      } else{
        this.$refs.printBarcodeModel.hide();
      }
    },
    returnTroubleMenu(){
      this.isReturnTroubleMenu = true;
      this.toInbound();
    },
    // toInboundToEnd() {
    //   this.isToEndInbound = true;
    //   this.toInbound();
    // },
    toInbound() {
      let reqKakoList = ShippingType.reqKakoList(this.statusFilter);
      api.registerInbound(this.memberId, this.item.janCode, this.item.asin, this.item.productNameEn, this.item.orderId, this.item.additionalCount, this.updateStatus, this.janFilter, reqKakoList, (data) => {
        var itemArray = [];
        itemArray.push(data.items);
        itemArray.push(data.setItems);
        itemArray.push(data.setProductDetailInfos);
        itemArray.push(data.slcAnalysisPointToday);
        itemArray.push(data.slcAnalysisPointAll);
        itemArray.push(data.troubleProductInfos);
        itemArray.push(data.requiredSetAsin); // 必ずfalseが返却される（セット商品を入庫した際に対象ASINが集約可能か？をチェックする為に利用する）
        itemArray.push(this.isToEndInbound); // これで対象会員の入庫を終了するかを判別
        itemArray.push(this.isReturnTroubleMenu); // これで入庫後に管理品画面に戻るかを判別
        this.$emit('updateItems', itemArray);
        if(this.isOutputBarcode){
          this.printBarcode();
        }
      });
      // ポップアップを閉じる
      if(this.isDangerPopup === '1'){
        this.$refs.printBarcodeModelDanger.hide();
      } else{
        this.$refs.printBarcodeModel.hide();
      }
    },
  },
};
</script>

<style scoped>

.abc{
  background-color: black;
  color: white;
  border-radius: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media print, screen {
  html,body {
    height: auto;
    margin: 0;
    padding: 0;
  }
  .body {
    font-size: 0.3rem;
    text-align: center;
    border: 1px;
  }
  .margin-top-1{
    margin-top: 1px;
  }
}
.barcode-text{
  text-align: center;
  font-size: 5px;
}
</style>
